import { FormattedMessage, InvoiceExpandedSummary, useMelioIntl } from '@melio/ar-domain';
import { Group, Text } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';

type InvoiceSummaryTitleProps = {
  expandedInvoice: InvoiceExpandedSummary;
};

export const InvoiceSummaryTitle = forwardRef<InvoiceSummaryTitleProps>(({ expandedInvoice }, ref) => {
  const { formatCurrency } = useMelioIntl();

  return (
    <Group alignItems="center" justifyContent="space-between" ref={ref}>
      <Text textStyle="heading3Semi">
        <FormattedMessage id="ar.dashboard.activities.InvoiceDrawer.body.summary.title.header.text" />
      </Text>
      <Text textStyle="heading3Semi">{formatCurrency(expandedInvoice.summary.totalAmount)}</Text>
    </Group>
  );
});
